// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
// getConfigsInfotools, getConfigInfotools, addConfigInfotools, updateConfigInfotools, deleteConfigInfotools
import {
    getConfigsInfotools as listConfigInfotoolsAPI,
    getConfigInfotools as getConfigInfotoolsAPI,
    addConfigInfotools as addConfigInfotoolsAPI,
    updateConfigInfotools as updateConfigInfotoolsAPI,
    deleteConfigInfotools as deleteConfigInfotoolsAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { configInfotoolsApiResponseError, configInfotoolsApiResponseSuccess } from './actions';
import { ConfigInfotoolsActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getConfigInfotools({ payload: { id } }) {
    try {
        const response = yield call(getConfigInfotoolsAPI, id );
        const configInfotoolsItem = response.data.data;
        yield put(configInfotoolsApiResponseSuccess(ConfigInfotoolsActionTypes.GET_CONFIG_INFOTOOLS, configInfotoolsItem));
    } catch (error) {
        yield put(configInfotoolsApiResponseError(ConfigInfotoolsActionTypes.GET_CONFIG_INFOTOOLS, error));
    }
}

function* addConfigInfotools({payload:configInfotools}){
    try{
        const response = yield call(addConfigInfotoolsAPI,{...configInfotools})
        const configInfotoolsItem = response.data
        yield put(configInfotoolsApiResponseSuccess(ConfigInfotoolsActionTypes.ADD_CONFIG_INFOTOOLS,configInfotoolsItem))
    } catch(error){
        yield put(configInfotoolsApiResponseError(ConfigInfotoolsActionTypes.ADD_CONFIG_INFOTOOLS,error))
    }
}

function* updateConfigInfotools({payload:configInfotools}){
    try{
        const response = yield call(updateConfigInfotoolsAPI,{...configInfotools})
        const configInfotoolsItem = response.data.data
        yield put(configInfotoolsApiResponseSuccess(ConfigInfotoolsActionTypes.UPDATE_CONFIG_INFOTOOLS,configInfotoolsItem))
    }catch(error){
        yield put(configInfotoolsApiResponseError(ConfigInfotoolsActionTypes.UPDATE_CONFIG_INFOTOOLS,error))
    }
}
function* deleteConfigInfotools({payload:{id}}){
    try{
        const response = yield call(deleteConfigInfotoolsAPI,id)
        const configInfotoolsItem = response.data.id
        yield put(configInfotoolsApiResponseSuccess(ConfigInfotoolsActionTypes.DELETE_CONFIG_INFOTOOLS,configInfotoolsItem))
    }catch(error){
        yield put(configInfotoolsApiResponseError(ConfigInfotoolsActionTypes.DELETE_CONFIG_INFOTOOLS,error))
    }
}

/**
 * List contactos
 */
function* listConfigInfotools({payload:params}) {
    try {
        const response = yield call(listConfigInfotoolsAPI, { ...params });
        const listaConfigInfotools = response.data.data;
        yield put(configInfotoolsApiResponseSuccess(ConfigInfotoolsActionTypes.LIST_CONFIGS_INFOTOOLS, listaConfigInfotools));
    } catch (error) {
        yield put(configInfotoolsApiResponseError(ConfigInfotoolsActionTypes.LIST_CONFIGS_INFOTOOLS, error));
    }
}


export function* watchGetConfigInfotools(): any {
    yield takeEvery(ConfigInfotoolsActionTypes.GET_CONFIG_INFOTOOLS, getConfigInfotools);
}

export function* watchListConfigInfotools(): any {
    yield takeEvery(ConfigInfotoolsActionTypes.LIST_CONFIGS_INFOTOOLS, listConfigInfotools);
}

export function* watchAddConfigInfotools():any{
    yield takeEvery(ConfigInfotoolsActionTypes.ADD_CONFIG_INFOTOOLS,addConfigInfotools)
}
export function* watchUpdateConfigInfotools():any{
    yield takeEvery(ConfigInfotoolsActionTypes.UPDATE_CONFIG_INFOTOOLS,updateConfigInfotools)
}
export function* watchDeleteConfigInfotools():any{
    yield takeEvery(ConfigInfotoolsActionTypes.DELETE_CONFIG_INFOTOOLS,deleteConfigInfotools)
}


function* configInfotoolsSaga(): any {
    yield all([
        fork(watchGetConfigInfotools),
        fork(watchListConfigInfotools),
        fork(watchAddConfigInfotools),
        fork(watchUpdateConfigInfotools),
        fork(watchDeleteConfigInfotools),
    ]);
}

export default configInfotoolsSaga;
